<template>
  <van-sticky
    v-if="tabIsFixed"
    :offset-top="topHeight"
    @change="changeFixedStatus"
  >
    <van-tabs
      v-model="tabIndex"
      :swipe-threshold="1"
      :class="[
        _.tabs,
        center && _.center,
        $scopedSlots.default && _.custom,
        isFixed && _.fixedTabs,
      ]"
    >
      <van-tab v-for="(item, index) in tabData" :key="item.value">
        <div slot="title" @click.stop="tabIndex = index">
          <slot :item="item" :index="index" :isActive="tabIndex === index">
            <div :class="_.item">
              {{ item.label }}
            </div>
          </slot>
        </div>
      </van-tab>
    </van-tabs>
  </van-sticky>

  <van-tabs
    v-else
    v-model="tabIndex"
    :swipe-threshold="1"
    :class="[_.tabs, center && _.center, $scopedSlots.default && _.custom]"
  >
    <van-tab v-for="(item, index) in tabData" :key="item.value">
      <div slot="title" @click.stop="tabIndex = index">
        <slot :item="item" :index="index" :isActive="tabIndex === index">
          <div :class="_.item">
            {{ item.label }}
          </div>
        </slot>
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      center: {
        type: Boolean,
      },
      value: {
        type: null,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
      tabIsFixed: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        topHeight: 0,
        isFixed: false,
      }
    },

    computed: {
      tabIndex: {
        get() {
          return this.value
        },
        set(v) {
          this.$emit('input', v)
        },
      },

      tabData() {
        return this.data.map(item =>
          typeof item === 'string'
            ? {
                label: item,
                value: item,
              }
            : {
                ...item,
                label: item.label || item.title || item.name || item.cityName,
                value:
                  item.value ||
                  item.id ||
                  item.label ||
                  item.title ||
                  item.name ||
                  item.cityCode,
              },
        )
      },
    },

    mounted() {
      this.$eventBus.on('setPageHeaderHeight', ({ pageHeaderHeight }) => {
        if (!this.hasSet) {
          this.topHeight = pageHeaderHeight
          this.hasSet = true
        }
      })
    },
    beforeDestroy() {
      this.$eventBus.off('setPageHeaderHeight')
    },
    methods: {
      changeFixedStatus(isFixed) {
        this.isFixed = isFixed
      },
    },
  })
</script>

<style lang="scss" module="_">
  .tabs {
    margin: 0 calc(0vw - var(--padding, 0vw));

    .item {
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: center;
    }

    :global {
      .van-tabs__wrap {
        height: var(--height, 44px) !important;
      }

      .van-tabs__nav {
        background: transparent;
        padding-left: var(--padding, 0vw) !important;
        padding-right: var(--padding, 0vw) !important;
        padding-bottom: 0 !important;
      }

      .van-tab {
        flex: unset !important;
        padding: 0 !important;

        + .van-tab {
          margin-left: var(--gap, 24px);
        }
      }

      .van-tab__text {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
        line-height: 22px;
        // 关键
        white-space: nowrap;
      }

      .van-tab--active .van-tab__text {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
      }

      .van-tabs__line {
        bottom: 4px;
        width: 15px;
        height: 4px;
        background: #df0010;
        border-radius: 2px;
      }
    }

    &.center {
      :global {
        .van-tabs__nav {
          justify-content: center;
        }
      }
    }

    &.custom {
      :global {
        .van-tabs__line {
          display: none;
        }
      }
    }
    &.fixedTabs {
      :global {
        .van-tabs__wrap {
          height: 50px !important;
        }

        .van-tabs__nav {
          background: #ffffff;
        }

        .van-tab__text {
          font-weight: normal;
          line-height: 22px;
          // 关键
          white-space: nowrap;

          .item {
            font-size: 16px;
            background: transparent !important;
            color: var(--unchecked-fixed-tabcolor) !important;
          }
        }

        .van-tab--active .van-tab__text {
          font-weight: 500;
          line-height: 25px;

          .item {
            font-size: 16px !important;
            color: var(--checked-fixed-tabcolor) !important;
          }
        }

        .van-tabs__line {
          display: block !important;
          bottom: 7px;
          width: 24px;
          height: 3px;
          background: var(--fixed-tab-themecolor) !important;
          border-radius: 2px;
        }
      }
    }
  }
</style>
